var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseSmallGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "9px",
    height: "9px",
    viewBox: "0 0 9 9",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Shape Copy 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Designs",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Product-Table--dropdowns-and-tooltips",
    transform: "translate(-339.000000, -301.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "HIDECOLL",
    transform: "translate(159.000000, 290.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Shape-Copy-2",
    points: "189 11.9064286 188.093571 11 184.5 14.5935714 180.906429 11 180 11.9064286 183.593571 15.5 180 19.0935714 180.906429 20 184.5 16.4064286 188.093571 20 189 19.0935714 185.406429 15.5"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseSmallGrey);
export default __webpack_public_path__ + "static/media/close-small-grey.1065e5f1ab73270d208e21eab5bfaf25.svg";
export { ForwardRef as ReactComponent };